import { useApi } from '@/api';
import { ChartTimeFilter } from '@/components';
import { Flex, DisplaySwitch, ChartSkeleton } from '@blockanalitica/ui';
import { useMemo, useState } from 'react';
import AssetLiquidationsGraph, {
  AssetData
} from './components/AssetLiquidationsGraph';
import DatesLiquidationsGraph, {
  DatesData
} from './components/DatesLiquidationsGraph';
import { useSearchParams } from '@/hooks';

export default function HistoricTabs({
  marketAddress
}: {
  marketAddress: string;
}) {
  const [chartDaysAgo, setChartDaysAgo] = useState('30');
  const [activeDisplayOption, setActiveDisplayOption] = useSearchParams(
    'tab',
    'date'
  );
  const displayOptions = useMemo(
    () => [
      { key: 'date', value: 'By Date' },
      { key: 'asset', value: 'By Asset' }
    ],
    []
  );

  const timeFilter = useMemo(
    () => (
      <ChartTimeFilter activeOption={chartDaysAgo} onChange={setChartDaysAgo} />
    ),
    [chartDaysAgo]
  );

  const [data, error] = useApi<AssetData[] | DatesData>({
    url: `/markets/${marketAddress}/liquidations/historic/`,
    queryParams: {
      days_ago: chartDaysAgo,
      type: activeDisplayOption
    }
  });

  if (error) {
    throw error;
  }

  if (!data) {
    return <ChartSkeleton />;
  }

  return (
    <Flex flexDirection="column" gap="xs">
      <DisplaySwitch
        data={displayOptions}
        activeOption={activeDisplayOption as string}
        onChange={setActiveDisplayOption}
      />
      {activeDisplayOption === 'asset' ? (
        <AssetLiquidationsGraph
          data={data as AssetData[]}
          timeFilter={timeFilter}
        />
      ) : (
        <DatesLiquidationsGraph
          data={data as DatesData}
          timeFilter={timeFilter}
          chartDaysAgo={chartDaysAgo}
        />
      )}
    </Flex>
  );
}
